var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authBackground"},[_c('div',{staticClass:"logoMain"},[_c('img',{staticClass:"logoImg",attrs:{"src":require("assets/img/home/img_login_photo.png")}})])])
}]

export { render, staticRenderFns }